import { useMemo } from 'react'

import {
  SEARCH_MAX_DISTANCE_DEFAULT_KM,
  SEARCH_MAX_DISTANCE_DEFAULT_MI,
  SEARCH_MAX_DISTANCE_MAX_KM,
  SEARCH_MAX_DISTANCE_MAX_MI,
  SEARCH_MAX_DISTANCE_MIN_KM,
  SEARCH_MAX_DISTANCE_MIN_MI
} from '@/lib'

export const useSearchDistanceValues = (isMetricSystem: boolean) =>
  useMemo(
    () => ({
      defaultValue: isMetricSystem ? SEARCH_MAX_DISTANCE_DEFAULT_KM : SEARCH_MAX_DISTANCE_DEFAULT_MI,
      maxValue: isMetricSystem ? SEARCH_MAX_DISTANCE_MAX_KM : SEARCH_MAX_DISTANCE_MAX_MI,
      minValue: isMetricSystem ? SEARCH_MAX_DISTANCE_MIN_KM : SEARCH_MAX_DISTANCE_MIN_MI,
      units: isMetricSystem ? 'kilometers' : 'miles',
      unitsShort: isMetricSystem ? 'km' : 'mi'
    }),
    [isMetricSystem]
  )
